import React from 'react';
import PolicyPage from './PolicyPage';

// Content from Admin → policies (falls back to the recommended text until saved).
function PrivacyPolicy() {
  return <PolicyPage policyKey="privacyPolicy" icon="fa-shield" />;
}

export default PrivacyPolicy;
